export default {"src":"/_next/static/media/apartments-icon.b1a2097c.svg","height":93,"width":91,"blurWidth":0,"blurHeight":0};